import { useAppDispatch } from "app/hooks";
import { fetchRecentOrders } from "app/myOrdersSlice";
import { useCallback, useState } from "react";
import UserService from "services/userService";
import { OrderStatus } from "types/orderType";
import { calculateDateBeforeOneYear } from "utils/dateUtils";

// 장바구니 및 최근 주문 내역 조회를 위한 custom hook
const useFetchOrderInfo = (status?: OrderStatus | "ALL") => {
  const dispatch = useAppDispatch();
  const [isFetching, setIsFetching] = useState(false);

  const fetchOrderInfos = useCallback(async () => {
    setIsFetching(true);
    try {
      const response = await UserService.getMyOrders(
        calculateDateBeforeOneYear(),
        undefined,
        0,
        status ?? "ALL"
      );
      // API 응답 shape가 바뀌더라도 장바구니 화면이 크래시 나지 않도록 안전하게 정규화
      const normalizedOrders = Array.isArray((response as any)?.content)
        ? (response as any).content
        : Array.isArray(response)
          ? response
          : [];
      dispatch(fetchRecentOrders(normalizedOrders));
    } catch (error) {
      console.error("Error fetching orders:", error);
    } finally {
      setIsFetching(false);
    }
  }, [dispatch, status]);

  return [isFetching, fetchOrderInfos] as const;
};

export default useFetchOrderInfo;
